import { Component } from '@angular/core';

@Component({
  selector: 'uni-layout-guest',
  templateUrl: './uni-layout-guest.component.html',
  styleUrls: ['./uni-layout-guest.component.scss'],
})
export class UniLayoutGuestComponent {
}
